// This file is generated by a script and should not be modified directly.
const markdown: string =
  "- `null` lorsque le champs `identifiant.cfd` est `null`.\n- Pour distinguer les diplômes remplacés des diplômes remplaçant, il faut se référer aux dates d'ouverture et de fermeture des diplômes.\n"
export default markdown
